<template>
  <div class="container">
    <b-row>
      <b-col></b-col>
      <b-col cols="6">
        <b-form @submit="login" @reset="clear" onsubmit="return false;">
          <h2>Giriş Yap</h2>
          <div class="separator"></div>

          <b-form-group label="Kullanıcı Adı" label-for="username">
            <b-form-input id="username" v-model="user.username" required></b-form-input>
          </b-form-group>

          <b-form-group label="Şifre" label-for="password">
            <b-form-input id="password" type="password" v-model="user.password" required></b-form-input>
          </b-form-group>

          <b-row align-h="end">
            <b-button type="submit" variant="primary" :disabled="loading">
              Giriş Yap
            </b-button>
            <b-button type="reset" variant="danger" style="margin-left: 5px" :disabled="loading">
              Temizle
            </b-button>
          </b-row>
        </b-form>
      </b-col>
      <b-col></b-col>
    </b-row>

    <!-- Yükleniyor Ekranı -->
    <div v-if="loading" class="loading-overlay">
      <b-spinner variant="light" label="Yükleniyor..." class="loading-spinner"></b-spinner>
      <p class="loading-text">Giriş yapılıyor, lütfen bekleyin...</p>
    </div>
  </div>
</template>

<script>
import UserService from "../../service/UserService";

export default {
  name: "login",
  data() {
    return {
      user: { username: '', password: '' },
      loading: false,
    };
  },
  methods: {
    async login() {
      this.loading = true;

      try {
        localStorage.setItem('user', JSON.stringify(this.user));
        const result = await UserService.login(this.user);

        if (result.authorities) {
          this.user.role = result.authorities[0].authority;
          this.$store.commit('setUserRole', result.authorities[0].authority);
        }

        this.$store.commit('setUsername', result.username);
        this.$store.commit('setClientId', result.clientId);
        this.$store.commit('setBalanceText', result.balanceText);
        localStorage.setItem('user', JSON.stringify(this.user));

        if (this.$store.state.userRole === 'ROLE_ADMIN') {
          await this.$router.push({name: 'AdminOrderList'});
        } else {
          await this.$router.push({name: 'Order'});
        }
      } catch (error) {
        localStorage.removeItem('user');
        this.$alert(this, "Giriş başarısız! Lütfen bilgilerinizi kontrol edin.");
      } finally {
        this.loading = false;
      }
    },

    clear() {
      this.user.username = '';
      this.user.password = '';
    }
  }
};
</script>

<style>
.separator {
  border-bottom: solid 1px #ccc;
  margin-bottom: 15px;
}

/* Loading ekranı */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7); /* Siyah yarı saydam arka plan */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-spinner {
  width: 4rem;
  height: 4rem;
}

.loading-text {
  color: white;
  font-size: 1.2rem;
  margin-top: 10px;
}
</style>
